// Os textos do pagamento do comprador, depois do #246 ("quem registra quita").
//
// Num ROMANEIO (o documento que um produtor do Rizoma formalizou), o pagamento
// que o comprador registra nasce CONFIRMADO: o produtor não confirma nada — se o
// dinheiro não entrar, ele marca "Não recebi". E desde os avisos pelo WhatsApp o
// produtor com conta é AVISADO do registro (`pagamento.informado`).
//
// No REGISTRO PRÓPRIO (o documento que o comprador anotou) o pagamento também
// fica pago na hora, mas não há aviso pelo número do Rizoma — o canal continua
// sendo o WhatsApp de quem pagou.
//
// Puras e em `shared/`: o diálogo usa, e o teste de "nenhum texto de ROMANEIO
// diz que o produtor confirma" olha para elas, não para o JSX.

export interface DocumentoDoPagamento {
  natureza: string;
  produtorNome: string;
}

/** A descrição do diálogo "Registrar pagamento" (um documento ou um lote). */
export function descricaoRegistrarPagamento(linhas: DocumentoDoPagamento[]): string {
  const romaneios = linhas.filter(l => l.natureza === "ROMANEIO");
  const registros = linhas.filter(l => l.natureza !== "ROMANEIO");
  const produtores = romaneios.map(l => l.produtorNome).filter((n, i, a) => a.indexOf(n) === i);

  if (registros.length === 0) {
    if (produtores.length === 1) {
      return `O pagamento fica registrado e ${produtores[0]} é avisado. Se o dinheiro não entrar, ele marca Não recebi.`;
    }
    return "Cada pagamento fica registrado e cada produtor é avisado. Se o dinheiro não entrar, ele marca Não recebi.";
  }
  if (romaneios.length === 0) {
    return "Fica pago na hora, para você e para o produtor. O app não manda mensagem de registro próprio — avise o produtor.";
  }
  return "Tudo fica pago na hora. Os produtores dos romaneios são avisados e, se o dinheiro não entrar, marcam Não recebi; "
    + "nos registros próprios o app não manda mensagem — avise o produtor.";
}

/** "Pagar a carga": um lançamento por produtor; quem tem conta no Rizoma é avisado. */
export const AVISO_PAGAR_CARGA = "Todos ficam pagos; quem tem conta no Rizoma é avisado.";

/** O "Não recebi" do produtor: o comprador vê o motivo e é avisado. */
export function descricaoNaoRecebi(compradorNome: string): string {
  return `o romaneio volta a ficar em aberto para os dois, e ${compradorNome} vê o motivo no A pagar dele e é avisado.`;
}

/** O "Recebi" do próprio produtor (lançamento direto). */
export const DESCRICAO_RECEBI = "Marca a venda como paga no Cacho e no Mercado — o comprador também passa a ver Paga.";
